import React from 'react'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'
import { CSVLink } from 'react-csv'
import styles from './ButtonStyles'
const DownloadCsvButton = ({
  headers = [],
  csvName = 'CSV.csv',
  children,
  separator = ';',
  results = [],
}) => {
  const classes = styles()
  return (
    <CSVLink
      data={results}
      headers={headers}
      filename={csvName}
      separator={separator}
      style={{ textDecoration: 'none' }}
    >
      <Button className={classes.buttonCustom}>{children}</Button>
    </CSVLink>
  )
}

DownloadCsvButton.propTypes = {
  children: PropTypes.any,
  csvName: PropTypes.string,
  headers: PropTypes.any,
  results: PropTypes.array,
  separator: PropTypes.string,
}

export default DownloadCsvButton
